import React, { Component } from "react";
import store from "../../store";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";

import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Navbar from "../Navbar/Navbar";
import GridCars from "../GridCars/GridCars";
import Footer from "../Footer/Footer";

import { createMuiTheme } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";

const ColorButton = withStyles(theme => ({
  root: {
    fontFamily: "Arial",
    fontWeight: "bold",
    borderColor: green[500],
    backgroundColor: green[500],
    color: theme.palette.getContrastText(green[50]),
    color: green[50],
    borderRadius: 20,
    "&:hover": {
      backgroundColor: green[100],
      color: theme.palette.getContrastText(green[500]),
      color: green[700]
    }
  }
}))(Button);

const imgStyle = {
  width: "50%",
  height: "50%",
  display: "block",
  marginLeft: "auto",
  marginRight: "auto"
};

class MainMenu extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}

  useStyles = () =>
    makeStyles(theme => ({
      button: {
        margin: theme.spacing(1),
        primary: green
      },
      input: {
        display: "none"
      }
    }));

  startHandler = () => {};

  leaderboardHandler = () => {};

  render() {
    const classes = this.useStyles();

    return (
      <div>
        <Navbar />
        <GridCars />
        <Footer />
      </div>
    );
  }
}

export default MainMenu;
